// 直播管理路由
export default {
    path: 'raise',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '众筹管理'},
    children: [{
        path: 'project',
        component: () => import('@/components/RouterView'),
        redirect: '/raise/project/list',
        meta: { title: '众筹项目'},
        children: [{
            path: 'list',
            component: () => import('@/views/raise/project/list.vue'),
            meta: {title: '众筹项目列表'}
        },{
            path: 'edit/baseInfo/:id',
            component: () => import('@/views/raise/project/edit/baseInfo.vue'),
            meta: {title: '众筹项目编辑'},
            props:true
        },{
            path: 'edit/ticketPrice/:id',
            component: () => import('@/views/raise/project/edit/ticketPrice.vue'),
            meta: {title: '众筹项目编辑'},
            props:true
        },{
            path: 'sort',
            component: () => import('@/views/raise/project/sort.vue'),
            meta: {title: '众筹置顶设置'},
        }]
    },{
        path: 'audit',
        component: () => import('@/components/RouterView'),
        redirect: '/raise/audit/list',
        meta: { title: '众筹上线审核'},
        children: [{
            path: 'list',
            component: () => import('@/views/raise/audit/list.vue'),
            meta: {title: '审核列表'}
        }]
    },{
        path: 'order',
        component: () => import('@/components/RouterView'),
        redirect: '/raise/order/list',
        meta: { title: '订单管理'},
        children: [{
            path: 'list',
            component: () => import('@/views/raise/order/list'),
            meta: {title: '订单列表'}
        },{
            path: 'edit/:id',
            component: () => import('@/views/raise/order/edit'),
            meta: {title: '订单详情'},
            props: true
        }]
    }]
}